<template>
    <div id="mainArea" class="mainArea">
        <main class="container_pc">
            <!-- ▼▼▼ タイトルエリア ▼▼▼ -->
            <h2 class="hdg2-mitsumori">お見積り結果<span class="logo logo-header-smaphonenkin logo-header-right"></span></h2>
            <!-- ▲▲▲ タイトルエリア ▲▲▲ -->

            <!-- ▽▽▽ コンテンツエリア ▽▽▽ -->
            <div class="frame_plan">
                <p class="font1">【お見積り条件】<span class="font13">（計算基準日：{{ baseYear }}年{{ baseMonth }}月{{ baseDay }}日）</span></p>
                <span class="span_profile">
                    生年月日：{{ year }}（{{ warekiYear }}）年{{ month }}月{{ day }}日
                </span>
                <span class="span_profile">
                    性別：{{ displaySex }}
                </span>
                <span class="span_helpicon">
                    <img class="helpicon_shosai" src="../image/Pen.png"><span class="helpicon_word" @click="backToseinengappiNyuryoku">変更</span>
                </span>
            </div>
        </main>

        <main class="container_phone">
            <div class="red_frame">
                <p class="font2">月払保険料を変更すると、保険料に応じた<br>お見積り結果が確認できます</p>
                <div class="frame_plan2">
                    <div>
                        <p class="font1">月払保険料
                            <img class="helpicon_shosai" src="../image/Question.png" v-b-modal.modal-value2>
                        </p>
                        <select id="stp2" class="input-p-mitsumori2" v-model="selectedStp" @change="changeStp">
                            <option value="1">3,000円</option>
                            <option value="2">5,000円</option>
                            <option value="3">10,000円</option>
                            <option value="4">20,000円</option>
                            <option value="5">30,000円</option>
                        </select>
                        <span class="nenFixWord"><span class="triangle"></span></span>
                    </div>

                    <!-- ▽▽▽ シミュレーションエリア ▽▽▽ -->
                    <div class="frame_plan5_triangle">
                        <span class="triangle2"></span>
                    </div>

                    <div class="frame_plan5 center">
                        <span class="font6">保険期間中は返戻率が<span class="font7">100</span>%以上となります</span>
                    </div>

                    <div class="frame_plan5">
                        <div class="uketorikingaku_10">
                            <span class="plan_font1"><span class="plan_font2">{{ ruikeiHokenryo }}</span>円</span>
                            <span class="plan_font3"><span class="plan_font2">{{ mankiHokenkin }}</span>円</span>
                            <span class="plan_font5">{{ mankiHokenkinHenreiritsu }}%</span>

                            <span class="sikumi1"><span class="age">{{ age }}</span>歳</span>
                            <span class="sikumi2"><span class="age">{{ age3 }}</span>歳</span>
                            <span class="sikumi3"><span class="age">{{ age10 }}</span>歳</span>

                            <span class="sikumi4">ご契約</span>
                            <span class="sikumi5">払込期間満了</span>
                            <span class="sikumi6">満期</span>
                        </div>
                    </div>

                    <div class="frame_plan5">
                        <p class="font8">将来のお受取額<span class="plan_font4">※２</span></p>

                        <table class="table_uketorigaku">
                            <colgroup>
                                <col style="width: 14%;">
                                <col style="width: 27%;">
                                <col style="width: 32%;">
                                <col style="width: 27%;">
                            </colgroup>
                            <tr>
                                <td class="category_caption">経過</td>
                                <td class="category_caption">累計保険料</td>
                                <td class="category_caption">死亡保険金・<br>解約払戻金<br><span class="font9">（返戻率</span><span class="plan_font4">※３</span><span class="font9">）</span></td>
                                <td class="category_caption">傷害死亡<br>保険金</td>
                            </tr>
                            <tr>
                                <td class="category_content plan_font6">3年<span class="plan_font4">※４</span></td>
                                <td class="category_content" rowspan="4">{{ ruikeiHokenryo }}円</td>
                                <td class="category_content">{{ shiboHokenkin3 }}円<br><span class="font_red">（{{ shiboHokenkinHenreiritsu3 }}%）</span></td>
                                <td class="category_content">{{ shogaiShiboHokenkin3 }}円</td>
                            </tr>
                            <tr>
                                <td class="category_content plan_font6">5年</td>
                                <td class="category_content">{{ shiboHokenkin5 }}円<br><span class="font_red">（{{ shiboHokenkinHenreiritsu5 }}%）</span></td>
                                <td class="category_content">{{ shogaiShiboHokenkin5 }}円</td>
                            </tr>
                            <tr>
                                <td class="category_content plan_font6">7年</td>
                                <td class="category_content">{{ shiboHokenkin7 }}円<br><span class="font_red">（{{ shiboHokenkinHenreiritsu7 }}%）</span></td>
                                <td class="category_content">{{ shogaiShiboHokenkin7 }}円</td>
                            </tr>
                            <tr>
                                <td class="category_content plan_font7">10年</td>
                                <td class="category_content">{{ shiboHokenkin10 }}円<br><span class="font_red">（{{ shiboHokenkinHenreiritsu10 }}%）</span></td>
                                <td class="category_content">{{ shogaiShiboHokenkin10 }}円</td>
                            </tr>
                        </table>
                    </div>

                    <p class="font10 indent3">
                        ※１&nbsp;この保険には、配当金はありません。
                    </p>

                    <p class="font10 indent3">
                        ※２&nbsp;累計保険料、死亡保険金および解約払戻金、傷害死亡保険金は、各年の計算基準日前日に対応する日の金額を表示しております。
                    </p>

                    <p class="font10 indent3">
                        ※３&nbsp;返戻率は「解約払戻金÷累計保険料」で計算しております。<br>返戻率は、小数第2位以下を切捨て表示しております。
                    </p>

                    <p class="font10 indent3">
                        ※４&nbsp;契約日から3年経過後の契約応当日（保険料払込期間満了日の翌日）の解約払戻金額は、{{ henreikingaku }}円（返戻率{{ henreikingakuHenreiritsu }}%）です。（解約日時点で、未払込保険料がある場合は、解約払戻金から差引きます。）
                    </p>
                    <!-- △△△ シミュレーションエリア △△△ -->
                </div>
            </div>
        </main>

        <main class="container_pc">
            <h2 class="hdg2-mitsumori2">お支払事由</h2>
            <div class="frame_plan3">
                <h2 class="hdg2-mitsumori3">
                    <P class="font3">傷害死亡保険金</P>
                </h2>
                <div class="click_summary"></div>
                <details class="c-faq" open>
                    <summary></summary>

                    <div class="frame_plan4">
                        <h2 class="hdg2-mitsumori4">お支払事由の概要</h2>
                        <p class="font4">傷害を直接の原因として死亡されたとき</p>

                        <h2 class="hdg2-mitsumori4">お支払いする金額</h2>

                        <p class="font4">
                            <span class="font_weight">【保険料払込期間中の場合】<br></span>
                            1カ月分の保険料&nbsp;×&nbsp;契約日から被保険者の死亡された日までの月数&nbsp;×&nbsp;1.1
                        </p>
                        <p class="font4">
                            <span class="font_weight">【保険料払込期間経過後の場合】<br></span>
                            1カ月分の保険料&nbsp;×&nbsp;36&nbsp;×&nbsp;1.1
                        </p>

                        <p class="font5 indent">
                            ・傷害死亡保険金のお支払いにあたっては、原因となる傷害が責任開始時以後に生じることが必要となります。
                        </p>

                        <p class="font5 indent">
                            ・対象となる傷害には疾病・老衰は含まれません。傷害に該当する事例・該当しない事例は例えば以下のとおりです。
                        </p>

                        <p class="font5 indent2">
                            該当する事例：交通事故・転倒、転落・溺水・食物等を詰まらせての窒息・炎天下等の高温による熱中症・登山での低酸素状態による適応不全症（高山病）等
                        </p>

                        <p class="font5 indent2">
                            該当しない事例：感染症・疾病による心不全・誤嚥性肺炎・エコノミークラス症候群等
                        </p>

                        <p class="font5">
                            なお、傷害を原因として死亡したときであっても、疾病を主たる原因として死亡したと認められる場合は、傷害死亡保険金をお支払いできません。
                        </p>
                    </div>
                </details>
            </div>

            <div class="frame_plan3">
                <h2 class="hdg2-mitsumori3">
                    <P class="font3">死亡保険金</P>
                </h2>
                <div class="click_summary"></div>
                <details class="c-faq" open>
                    <summary></summary>

                    <div class="frame_plan4">
                        <h2 class="hdg2-mitsumori4">お支払事由の概要</h2>
                        <p class="font4">傷害以外で死亡されたとき（傷害死亡保険金が支払われないとき）</p>

                        <h2 class="hdg2-mitsumori4">お支払いする金額</h2>
                        <p class="font4">
                            <span class="font_weight">【保険料払込期間中の場合】<br></span>
                            1カ月分の保険料 × 契約日から被保険者の死亡された日までの月数
                        </p>

                        <p class="font4">
                            <span class="font_weight">【保険料払込期間経過後の場合】<br></span>
                            被保険者の死亡された日における積立金と同額<span class="plan_font4">※</span>
                        </p>

                        <p class="font5 indent">
                            ※積立金とは、将来の保険金をお支払いするために保険料の中から積立てるお金をいいます。
                        </p>
                    </div>
                </details>
            </div>

            <div class="frame_plan3">
                <h2 class="hdg2-mitsumori3">
                    <P class="font3">満期保険金</P>
                </h2>
                <div class="click_summary"></div>
                <details class="c-faq" open>
                    <summary></summary>

                    <div class="frame_plan4">
                        <h2 class="hdg2-mitsumori4">お支払事由の概要</h2>
                        <p class="font4">保険期間満了時まで生存されていたとき</p>

                        <h2 class="hdg2-mitsumori4">お支払いする金額</h2>
                        <p class="font4">
                            満期保険金額
                        </p>
                    </div>
                </details>
            </div>

            <div class="frame_plan7">
                <img class="attentionicon" src="../image/Attention.png">
                <span class="font11">以降の画面のご利用時間について</span>
                <p class="font12">
                    お申込手続のご利用時間は、以下のとおりとなります。<span class="font_red">ご利用時間外に「次へ」ボタンを押すとエラーになります。恐れ入りますが、ご利用時間内に再度「お見積り」画面より入力をお願いします。</span>
                </p>

                <p class="font12">
                    <span class="margin_right">月～土曜日</span>8:00～24:00<br>
                    <span class="margin_right">日曜・祝日</span>8:00～23:30
                </p>

                <p class="font12">
                    【ご利用停止日】<br>
                    毎月25日直前の日曜日（19～25日のうちの日曜日）<br>
                    12/31～1/3、5/3～5/5
                </p>

                <p class="font5 indent">
                    ※上記ご利用停止日の前日は23:45までとなります。（ご利用停止日の前日が日曜日の場合は、23:30までとなります。）
                </p>
            </div>

            <div class="center">
                <button type="button" class="btn-next-new" @click="quoteRequest">
                    <span>次へ</span>
                </button>
                <!-- キャンペーンが開始するタイミングで有効化
                <div>
                    <img onerror="this.remove()" class="campaign_button" src="http://xxx/xxx.png" @click="campaignRequest">
                </div>
                -->
                <div>
                    <button type="button" class="btn-back-new" @click="backToseinengappiNyuryoku">
                        <span>戻る</span>
                    </button>
                </div>
            </div>
            <!-- △△△ コンテンツエリア △△△ -->
        </main>

        <div class="container_phone footer_align">
            <div class="center">
                <span class="span_font1">日本生命お客様サポートオフィス<br>
                    <a class="a_phone" href="tel:0120-996-832">0120-996-832</a>
                </span>

                <span class="span_font2">（通話料無料）<br><span class="margin_right">月～金曜日</span>9:00～18:00<br>（祝日、12/31～1/3を除く）</span>

                <div>
                    <div class="div_border">
                        <div class="nav-top2">
                            <p class="nav-top-txt" @click="scrollTopplanSekkei">
                                <span class="nav-top-icon">ページ上部へ戻る</span>
                            </p>
                        </div>
                    </div>
                </div>

                <span class="span_bottom">Copyright (C) 2026 日本生命保険相互会社</span>
            </div>
        </div>

        <!-- 月額保険料のモーダル画面 -->
        <b-modal id="modal-value2" centered scrollable>
            <template #modal-header>
                <img class="close_modal_button close_modal_button2" @click="closeModal()">
                <div>
                    <h2 class="hdg2-mitsumori5">月払保険料</h2>
                </div>
            </template>
            <span class="modal_font">保険料の払込回数は月払のみになります。</span>

            <template #modal-footer>
                <div class="center">
                    <button type="button" class="btn-close" @click="closeModal()">
                        <span>閉じる</span>
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<style scoped>
    /* <!---画面系-----------------------------------------------------------> */
    /* 赤背景 */
    .red_frame {
        padding: 16px 10px;
        border: 1px solid #EEEEEE;
        background-color: #e2041b;
        max-width: 908px;
        margin: 0 auto;
    }

    @media screen and (max-width: 575px) {
        .red_frame {
            max-width: none;
        }
    }

    /* frame_plan */
    .frame_plan {
        padding: 16px 11px;
        border: 1px solid #EEEEEE;
        border-radius: 12px;
        background-color: #FFFFFF;
        margin-top: 100px;
        margin-bottom: 16px;
    }

    .frame_plan2 {
        padding: 16px 8px;
        border: 1px solid #EEEEEE;
        border-radius: 12px;
        background-color: #FFFFFF;
        margin-bottom: 16px;
    }

    .frame_plan3 {
        border: 1px solid #EEEEEE;
        border-radius: 12px 12px 12px 12px;
        background-color: #FFFFFF;
        margin-bottom: 20px;
        position: relative;
    }

    .frame_plan4 {
        padding: 16px 15px;
        border: 1px solid #EEEEEE;
        border-radius: 0px 0px 12px 12px;
        background-color: #FFFFFF;
        border-left: none;
        border-right: none;
        border-bottom: none;
        overflow: hidden;
    }

    .frame_plan5 {
        padding: 10px 0px;
        background-color: #FFFFFF;
    }

    .frame_plan5_triangle {
        padding-top: 15px;
        padding-bottom: 20px;
        background-color: #FFFFFF;
    }

    .frame_plan7 {
        padding: 16px 15px;
        border: 1px solid #EEEEEE;
        border-radius: 12px;
        background-color: #FFFFFF;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: none;
        overflow: hidden;
    }

    /* <!---フォント系-------------------------------------------------------> */
    .span_profile {
        display: block;
        font-size: 14px;
    }

    /* h2タグ_お見積もり */
    .hdg2-mitsumori2 {
        border-left: 6px solid #ed1c24;
        padding: 5px 0px 0px 7px;
        width: 100%;
        font-weight: bold;
        font-size: 2.4rem;
        align-items: center;
        color: #333333;
        margin-top: 40px;
        margin-bottom: 10px;
    }

    .hdg2-mitsumori3 {
        padding-left: 7px;
        width: 100%;
        font-weight: 700;
        display: flex;
        align-items: center;
        color: #333333;
    }

    .hdg2-mitsumori4 {
        border-left: 6px solid #ed1c24;
        padding-left: 7px;
        width: 100%;
        font-weight: 700;
        font-size: 16px;
        align-items: center;
        color: #333333;
        margin-bottom: 7px;
    }

    .font1 {
        font-size: 17px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .font2 {
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        font-weight: bold;
    }

    .font3 {
        font-size: 17px;
        margin-top: 15px;
        margin-left: 10px;
        margin-bottom: 25px;
    }

    .font4 {
        font-size: 15px;
        margin-bottom: 7px;
    }

    .font5 {
        font-size: 12px;
        margin-top: 5px;
        margin-bottom: 0px;
        color: #949494;
    }

    .font6 {
        font-size: 17px;
        font-weight: bold;
        border-bottom: 3px dotted #F4511E;
    }

    .font7 {
        font-size: 25px;
    }

    .font8 {
        font-size: 17px;
        font-weight: bold;
    }

    .font9 {
        font-size: 15px;
        vertical-align: top;
    }

    .font10 {
        font-size: 12px;
        margin-top: 5px;
        margin-bottom: 0px;
    }

    .font11 {
        font-size: 16px;
        font-weight: bold;
    }

    .font12 {
        font-size: 15px;
        margin-top: 20px;
    }

    .font13 {
        font-size: 14px;
        font-weight: normal;
        float: right;
    }

    .font_weight {
        font-weight: bold;
        font-size: 14px;
    }

    @media screen and (max-width: 480px) {
        .hdg2-mitsumori2 {
            font-size: 18px;
        }

        .font4 {
            font-size: 14px;
        }

        .font5 {
            font-size: 11px;
        }

        .font6 {
            font-size: 15px;
        }

        .font7 {
            font-size: 23px;
        }

        .font9 {
            font-size: 12px;
        }

        .font10 {
            font-size: 10.7px;
        }

        .font12 {
            font-size: 14px;
        }

        .font13 {
            font-size: 11px;
            float: right;
        }
    }

    .plan_font1 {
        color: #0000ff;
        font-size: 17px;
        font-weight: bold;
        position: absolute;
        z-index: 2;
        top: 57px;
        left: 58px;
    }

    .plan_font2 {
        font-size: 28px;
    }

    .plan_font3 {
        color: #ed1c24;
        font-size: 17px;
        font-weight: bold;
        position: absolute;
        z-index: 2;
        top: 30px;
        left: 467px;
    }

    .plan_font4 {
        font-size: 9px;
        vertical-align: top;
    }

    .plan_font5 {
        color: #ed1c24;
        font-size: 17px;
        font-weight: bold;
        position: absolute;
        z-index: 2;
        top: 69px;
        left: 562px;
    }

    .plan_font6 {
        font-size: 16px;
        text-align: left;
        padding-left: 45px;
    }

    .plan_font7 {
        font-size: 16px;
        text-align: left;
        padding-left: 36px;
    }

    @media screen and (max-width: 767px) {
        .plan_font1 {
            font-size: 10px;
            top: 42px;
            left: 9px;
        }

        .plan_font2 {
            font-size: 17px;
        }

        .plan_font3 {
            font-size: 10px;
            top: 22px;
            left: 204px;
        }

        .plan_font5 {
            font-size: 12px;
            top: 46px;
            left: 261px;
        }

        .plan_font6 {
            font-size: 12px;
            padding-left: 3px;
        }

        .plan_font7 {
            font-size: 12px;
            padding-left: 3px;
        }
    }

    .font_red {
        color: #ed1c24;
    }

    /* <!---画像系-----------------------------------------------------------> */
    /* ヘルプアイコン全体 */
    .span_helpicon {
        align-items: center;
        display: flex;
        float: right;
        text-align: center;
        margin-top: -21px;
    }

    /* ヘルプアイコン_文言 */
    .helpicon_word {
        margin-left: 2px;
        text-decoration: underline;
        color: #0080FF;
        font-weight: bold;
        vertical-align: middle;
        font-size: 14px;
        cursor: pointer;
    }

    /* 注意アイコン */
    .attentionicon {
        height: 28px;
        display: inline-block;
        margin-top: -8px;
        position: relative;
        padding-right: 10px;
    }

    /* プランイメージ */
    .uketorikingaku_10 {
		background: url(../image/FigureB_PC.png) no-repeat;
        background-size: contain;
        width: 659px;
        height: 435px;
        margin: 0 auto;
        position: relative;
        white-space: pre;
    }

    @media screen and (max-width: 767px) {
        .uketorikingaku_10 {
            background: url(../image/FigureB.png) no-repeat;
            background-size: contain;
            width: 324px;
            height: 295px;
            margin: 0 auto;
            position: relative;
        }
    }

    /* <!---項目系-----------------------------------------------------------> */
    /* プルダウン */
    .input-p-mitsumori2 {
        box-sizing: border-box;
        display: inline;
        justify-content: center;
        align-items: center;
        padding: 16px 0px;
        width: 100%;
        height: 65px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;
        border-radius: 8px;
        flex: none;
        order: 0;
        flex-grow: 0;
        text-align: center;
        font-weight: bold;
        font-size: 22px;
        outline: none;
        box-shadow: 0 5px 10px -5px #cccccc;
    }
    /* ▼灰色 */
    .triangle2 {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        width: 0px;
        height: 0px;
        border-top: 7px solid #dcdcdc;
        border-top-width: 20px;
        border-right: 7px solid transparent;
        border-right-width: 20px;
        border-left: 7px solid transparent;
        border-left-width: 20px;
        z-index: 1;
        pointer-events: none;
    }

    /* テーブル */
    table.table_uketorigaku {
        width: 100%;
        vertical-align: middle;
        text-align: center;
    }

    table.table_uketorigaku td.category_caption {
        background-color: #f5f5f5;
        border: solid #dcdcdc 1px;
        font-size: 16px;
        font-weight: bold;
    }

    table.table_uketorigaku td.category_content {
        border: solid #dcdcdc 1px;
        font-size: 16px;
    }

    table.table_uketorigaku td.category_content .font_red {
        font-size: 15px;
    }

    @media screen and (max-width: 480px) {
        table.table_uketorigaku td.category_caption {
            font-size: 13px;
        }

        table.table_uketorigaku td.category_content {
            font-size: 13px;
        }

        table.table_uketorigaku td.category_content .font_red {
            font-size: 12px;
        }
    }

    /* アコーディオンメニュー */
    .c-faq {
        margin-top: -35px;
    }

    .c-faq summary {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
    }

    .c-faq summary::-webkit-details-marker {
        display: none;
    }

    .c-faq summary::before,
    .c-faq summary::after {
        position: absolute;
        content: "";
        display: block;
        transition: all 0.3s;
        background: #333333;
        top: -19px;
        right: 0;
        transform: translate(-50%, -50%);
        width: 20px;
        height: 2px;
    }

    .c-faq summary::before {
        transform: translate(-50%, -50%) rotate(90deg);
    }

    .c-faq[open] summary::before,
    summary details[open] summary::before {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    .click_summary {
        content: "";
        position: absolute;
        width: 100%;
        height: 46px;
        top: 0px;
        cursor: pointer;
    }

    .sikumi1 {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        z-index: 2;
        top: 380px;
        left: 20px;
    }

    .sikumi2 {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        z-index: 2;
        top: 380px;
        left: 187px;
    }

    .sikumi3 {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        z-index: 2;
        top: 380px;
        left: 577px;
    }

    .sikumi4 {
        font-size: 16px;
        position: absolute;
        z-index: 2;
        top: 405px;
        left: 18px;
    }

    .sikumi5 {
        font-size: 16px;
        position: absolute;
        z-index: 2;
        top: 405px;
        left: 164px;
    }

    .sikumi6 {
        font-size: 16px;
        position: absolute;
        z-index: 2;
        top: 405px;
        left: 577px;
    }

    .age {
        font-size: 19px;
    }

    @media screen and (max-width: 767px) {
        .sikumi1 {
            font-size: 12px;
            top: 263px;
            left: 6px;
        }

        .sikumi2 {
            font-size: 12px;
            top: 263px;
            left: 87px;
        }

        .sikumi3 {
            font-size: 12px;
            top: 263px;
            left: 279px;
        }

        .sikumi4 {
            font-size: 12px;
            top: 284px;
            left: 5px;
        }

        .sikumi5 {
            font-size: 12px;
            top: 284px;
            left: 68px;
        }

        .sikumi6 {
            font-size: 12px;
            top: 284px;
            left: 279px;
        }

        .age {
            font-size: 15px;
        }
    }

    /* キャンペーンページボタン */
    .campaign_button {
        width: 300px;
        margin-bottom: 20px;
    }
</style>

<script>
export default {
    name: "planSekkei",
    props: {
        show: {type: String, default: ""},
        age: {type: Number, default: 0},
        age3: {type: Number, default: 0},
        age10: {type: Number, default: 0},
        year: {type: String, required: true},
        month: {type: String, required: true},
        day: {type: String, required: true},
        sex: {type: String, default: ""},
        stp: {type: String, default: ""},
        warekiYear: {type: String, required: true},
        baseYear: {type: String, required: true},
        baseMonth: {type: String, required: true},
        baseDay: {type: String, required: true},
        mankiHokenkin: {type: String, required: true},
        ruikeiHokenryo: {type: String, required: true},
        henreikingaku: {type: String, required: true},
        henreikingakuHenreiritsu: {type: String, required: true},
        mankiHokenkinHenreiritsu: {type: String, required: true},
        shiboHokenkin3: {type: String, required: true},
        shiboHokenkin5: {type: String, required: true},
        shiboHokenkin7: {type: String, required: true},
        shiboHokenkin10: {type: String, required: true},
        shogaiShiboHokenkin3: {type: String, required: true},
        shogaiShiboHokenkin5: {type: String, required: true},
        shogaiShiboHokenkin7: {type: String, required: true},
        shogaiShiboHokenkin10: {type: String, required: true},
        shiboHokenkinHenreiritsu3: {type: String, required: true},
        shiboHokenkinHenreiritsu5: {type: String, required: true},
        shiboHokenkinHenreiritsu7: {type: String, required: true},
        shiboHokenkinHenreiritsu10: {type: String, required: true}
    },
    data: function() {
        return {
            selectedStp: this.stp,
            dispMankiHokenkin: this.mankiHokenkin,
        }
    },
    mounted: function() {
        setupDetailsAnimation();

        var obj = document.getElementById("stp2");
        if (this.selectedStp != "") {
            obj.style.border = "1px solid  #11aaf6";
        } else {
            obj.style.border = "1px solid #DDDDDD";
        }
    },
    computed: {
        displaySex() {
            switch (this.sex) {
                case "1": return "男性"
                case "2": return "女性"
                default:  return ""
            }
        },
    },
    watch: {
        show() {
            if (this.show == "planSekkei") {
                window.scrollTo({
                    top: 305,
                    behavior: "auto"
                })
            }
        },
        stp(newVal) {
            this.selectedStp = newVal;

            var obj = document.getElementById("stp2");
            if (this.selectedStp != "") {
                obj.style.border = "1px solid  #11aaf6";
            } else {
                obj.style.border = "1px solid #DDDDDD";
            }
        },
        mankiHokenkin(newVal) {
            this.dispMankiHokenkin = newVal
        }
    },
    methods: {
        //画面項目の値変更
        changeStp() {
            this.$emit("updStp", this.selectedStp);
        },
        closeModal() {
            this.$bvModal.hide("modal-value2");
        },
        backToseinengappiNyuryoku() {
            this.$emit("showSeinengappiNyuryoku");

            window.scrollTo({
                top: 0,
                behavior: "auto"
            })
        },
        quoteRequest() {
            this.$emit("sendShorichu");
        },
        scrollTopplanSekkei() {
            window.scrollTo({
                top: 0,
                behavior: "auto"
            })
        },
        //キャンペーン対応で使用するロジック
        campaignRequest() {
            this.$emit("sendCampaign");
        }
    }
}

function setupDetailsAnimation() {
    const details = document.querySelectorAll("div.frame_plan3");

    details.forEach(elem => {
        const summary = elem.querySelector("div.click_summary");
        const cfaq = elem.querySelector("details.c-faq");
        const content = elem.querySelector(".frame_plan4");

        summary.addEventListener("click", (e) => {
            e.preventDefault();

            if (cfaq.open) {
                const closeDetails = content.animate(
                    {
                        height: [content.offsetHeight + "px", 0],
                    },
                    {
                        duration: 200,
                        easing: "linear",
                    }
                );
                closeDetails.onfinish = () => {
                    cfaq.removeAttribute("open");
                }
            } else {
                cfaq.setAttribute("open", "true");

                const openDetails = content.animate(
                    {
                        height: [0, content.offsetHeight + "px"],
                    },
                    {
                        duration: 200,
                        easing: "linear",
                    }
                );
                openDetails.onfinish = () => {
                    cfaq.setAttribute("open", "false");
                }
            }
        });
    });
}
</script>